<template>
<div class="chapter">
<div class="inner_page">
<div id="fm3">
<p class="title"><span class="bold">WHERE</span></p>
<p class="title"><span class="bold">THE</span></p>
<p class="title"><span class="bold">BODIES</span></p>
<p class="title"><span class="bold">ARE</span></p>
<p class="title"><span class="bold">BURIED</span></p>
<p class="title1">christopher brookmyre</p>
<p class="title1a">
<img alt="Figure" class="imgepub" src="images/img_0001.jpg"/></p>
<p class="title2">Atlantic Monthly Press</p>
<p class="title2"><em class="italic">New York</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?00361612